<template>
    <div class="page">
        <div class="header">
            <img src="https://4d-ai.chat/img/logo.png" />
            <div>
                WIFI版AI模组管家软件
            </div>
        </div>
        <div class="banner">
            <div class="left">
                <div class="title">
                    智能连接，一键掌控
                </div>
                <div class="content">
                    革命性的 AI 模组管理解决方案，让您的智能设备连接更简单、管理更高效
                </div>
            </div>
            <div class="right"></div>
        </div>
        <div class="mainBox">
            <div class="item">
                <div class="title">蓝牙配网</div>
                <div class="content">一键快速连接智能设备，简化配网流程，支持多种设备类型，连接成功率高达99.9%</div>
            </div>
            <div class="item">
                <div class="title">设备管理</div>
                <div class="content">集中管理所有连接设备，实时监控状态，远程控制操作，设备分组管理更高效</div>
            </div>
            <div class="item">
                <div class="title">智能体角色配置</div>
                <div class="content">自定义AI助手角色，个性化对话风格，满足不同场景需求，打造专属智能管家</div>
            </div>
            <div class="item">
                <div class="title">声纹识别</div>
                <div class="content">高精度声纹识别技术，安全认证，多用户区分，语音控制更安全便捷</div>
            </div>
            <div class="item">
                <div class="title">历史对话</div>
                <div class="content">完整记录对话历史，智能分类检索，支持导出分享，随时回顾重要信息</div>
            </div>
            <div class="item">
                <div class="title">更多功能</div>
                <div class="content">持续更新更多实用功能，满足您的智能家居管理需求，敬请期待</div>
            </div>
        </div>
        <ContactUs></ContactUs>
        <div class="totop" @click.stop="toTop()" v-if="showGoTop">
            <img src="https://4d-ai.chat/img/totop.png">
        </div>
    </div>
</template>
<script>

import ContactUs from '@/components/ContactUs.vue';
export default {
    components: {
        ContactUs
    },
    data() {
        return {
            showGoTop: false,
        }
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll, true);
    },
    methods: {
        handleScroll() {
            let scrolltop = document.documentElement.scrollTop;
            if (scrolltop > window.innerHeight) {
                this.showGoTop = true
            } else {
                this.showGoTop = false
            }
        },
        toTop() {
            document.documentElement.scrollTop = 0;
        },
    }
}
</script>
<style scoped lang="less">
.page {
    box-sizing: border-box;

    .mainBox {
        width: 100%;
        background-color: #fff;
        padding: 80px 95.5px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        gap: 30px;

        .item {
            width: 550px;
            background-color: #f9fafb;
            padding: 32px;
            box-sizing: border-box;
            border-radius: 8px;

            .title {
                font-size: 20px;
                font-weight: 600;
                margin-bottom: 12px;
            }

            .content {
                font-size: 16px;
                color: #4c5563;
            }
        }
    }

    .banner {
        background-color: #2563eb;
        padding: 128px 104px;
        box-sizing: border-box;

        .left {
            flex: 1;

            .title {
                text-align: center;
                font-size: 48px;
                color: #fff;
                margin-bottom: 24px;
            }

            .content {
                text-align: center;
                font-size: 20px;
                color: #fff;
            }
        }

        .right {}
    }

    .header {
        height: 80px;
        background-color: #2d428e;
        padding: 0 50px;
        box-sizing: border-box;
        display: flex;
        line-height: 80px;
        color: #fff;
        font-size: 24px;

        img {
            height: 100%;
        }
    }
}
</style>